import Login from "../components/login/Login";

function LoginView() {
  return (
    <div style={{ height: 'inherit' }}>
      <Login />
    </div>
  )
}

export default LoginView;